<template>
  <div class="overflow: auto">
    <Table style="font-size:20px" :content="self" border stripe :columns="columns1" :data="data1"></Table>
    <br />
    <Page :total="total" @on-change="pagingSuery" show-elevator />
    <Button
      style="background: #2d8cf0;border-color: #2d8cf0;float: right;padding: 8px 30px;font-size: 20px"
      type="error"
      size="small"
      @click="AddNotification = true;content='';"
    >发布通知</Button>
    <Modal width="40" v-model="AddNotification" title="发布通知" @on-ok="Add()">
      通知内容：
      <Input v-model="content" style="width: 400px;margin-right:15px" />
      <br />
      <br />通知全体:
      <Select v-model="level" style="width:200px;margin-left: 20px;" placeholder="选择人员">
        <Option v-for="item in levels" :value="item.value" :key="item.value">{{ item.label }}</Option>
      </Select>
    </Modal>
  </div>
</template>

<script>
import { api } from "../biz/api";
export default {
  name: "Notification",

  data() {
    return {
      content: "",
      level: 0,
      AddNotification: false,
      pageNow: 0,
      self: this,
      total: 0,
      levels: [
        {
          value: "0",
          label: "全体人员"
        },
        {
          value: "1",
          label: "团队管理"
        }
      ],
      columns1: [
        {
          title: "通知内容",
          align: "center",
          key: "content"
        },
        {
          title: "发布时间",
          align: "center",
          key: "createTime"
        },
        {
          title: "通知全体",
          align: "center",
          key: "level"
        }
      ],
      data1: [{}]
    };
  },

  activated: function() {
    this.getData("");
  },
  mounted: function() {
    this.getData("");
  },
  methods: {
    getData() {
      api
        .NotifyList({
          pageNow: this.pageNow,
          pageSize: 10
        })
        .then(res => {
          this.total = res.body.data.total;
          this.data1 = res.body.data.list;
          this.data1.forEach(element => {
            if (element.level > 0) {
              element.level = this.toChinesNum(element.level) + "级团队";
            } else {
              element.level = "所有人";
            }
          });
        });
    },
    toChinesNum(num) {
      let changeNum = [
        "零",
        "一",
        "二",
        "三",
        "四",
        "五",
        "六",
        "七",
        "八",
        "九"
      ]; //changeNum[0] = "零"
      let unit = ["", "十", "百", "千", "万"];
      num = parseInt(num);
      let getWan = temp => {
        let strArr = temp
          .toString()
          .split("")
          .reverse();
        let newNum = "";
        for (var i = 0; i < strArr.length; i++) {
          newNum =
            (i == 0 && strArr[i] == 0
              ? ""
              : i > 0 && strArr[i] == 0 && strArr[i - 1] == 0
              ? ""
              : changeNum[strArr[i]] + (strArr[i] == 0 ? unit[0] : unit[i])) +
            newNum;
        }
        return newNum;
      };
      let overWan = Math.floor(num / 10000);
      let noWan = num % 10000;
      if (noWan.toString().length < 4) noWan = "0" + noWan;
      return overWan ? getWan(overWan) + "万" + getWan(noWan) : getWan(num);
    },

    pagingSuery(pageNow) {
      this.pageNow = pageNow;
      this.getData();
    },
    Add() {
      api
        .NotifyAdd({
          content: this.content,
          level: this.level
        })
        .then(() => {
          this.getData();
        });
    }
  }
};
</script>

<style scoped lang = 'less' >
</style>